export class TipoDestaqueICMS {
  static readonly NORMAL = 0;
  static readonly ISENTO = 1;
  static readonly NAO_TRIBUTADO = 2;
  static readonly SUSPENSO = 3;
  static readonly DIFERIDO = 4;

  static Listar() {
    return [
      { value: TipoDestaqueICMS.NORMAL, label: 'Normal' },
      { value: TipoDestaqueICMS.ISENTO, label: 'Isento' },
      { value: TipoDestaqueICMS.NAO_TRIBUTADO, label: 'Não Tributado' },
      { value: TipoDestaqueICMS.SUSPENSO, label: 'Suspenso' },
      { value: TipoDestaqueICMS.DIFERIDO, label: 'Diferido' },
    ];
  }
}
